import { getFromLocalStorage } from 'widget/actions';
import { useIsWorkingTime } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import useAwayMessages from './use-away-messages/use-away-messages';
import useDefaultMessages from './use-default-messages/use-default-messages';
import useWelcomeMessages from './use-welcome-messages/use-welcome-messages';

const useInitialMessageList = (): Env.Message[] => {
  const { widget } = useWidgetContext();

  const awayMessages = useAwayMessages();
  const defaultMessages = useDefaultMessages();
  const isWorkingTime = useIsWorkingTime();
  const welcomeMessages = useWelcomeMessages();

  const msgs = getFromLocalStorage<Env.Message[]>(
    `whatcrmWidgetMsgs${widget.instance_chat_key}`,
  );

  if (Array.isArray(msgs)) return msgs;
  if (!isWorkingTime) return awayMessages;
  if (welcomeMessages) return welcomeMessages;

  return defaultMessages;
};

export default useInitialMessageList;
